import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterPartnersProducts from 'views/products/partners-providers/filter'; // Importing filter component for partners products
import TablePartnersProducts from 'views/products/partners-providers/table'; // Importing table component for partners products
import DetailsPartnersProducts from 'views/products/partners-providers/details'; // Importing details component for partners products
import RecordPartnersProducts from 'views/products/partners-providers/record'; // Importing record component for partners products
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PartnersProvidersView class extending JetView
 */
export default class PartnersProvidersView extends JetView {
    /**
     * Configures the UI components for the Partners Providers view
     * @returns {Object} UI configuration object
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            rows: [
                PlayersView, // Adding PlayersView to the layout
                DetailsPartnersProducts, // Adding details view for partners products
                RecordPartnersProducts, // Adding record view for partners products
            ],
        };
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default page size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export', // Unique identifier for the export dropdown
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Option for Excel export
                        { id: '2', value: 'PDF' }, // Option for PDF export
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('datatable').getPager().config.size; // Get current page size
                            var page = $$('datatable').getPage(); // Get current page number
                            var first = size * page; // Calculate first record index
                            var last = first + size - 1; // Calculate last record index
                            if (value == 1) {
                                // If Excel export is selected
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Proveedor Partner', // Report name
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        ); // Filter records for export
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Proveedor Partner', // Filename for export
                                    ignore: { rating: true }, // Ignore rating column
                                    footer: false, // Do not include footer
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF export is selected
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Proveedor Partner', // Report name
                                            TypeReport: 'PDF', // Report type
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            ); // Filter records for export
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Proveedor Partner', // Filename for export
                                        autowidth: true, // Auto width for PDF
                                        ignore: { rating: true }, // Ignore rating column
                                        footer: false, // Do not include footer
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this), // Bind context
                    },
                },
            ],
        };
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply current theme
                    elements: [
                        { view: 'label', label: _('Proveedor Partner') }, // Label for the toolbar
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Icon for closing the view
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                FilterPartnersProducts, // Adding filter component
                TablePartnersProducts, // Adding table component
                toolbar, // Adding toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean',
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide',
                    cols: [left], // Left section with components
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up responsive behavior
     * @param {Object} grid - Reference to the grid component
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Check for small screen size
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the third child view (export dropdown)
                $$('pagerA').define('group', 1); // Define pager grouping
            }
        });
    }
}

// FILE DOCUMENTED
